import React, { useState, useEffect, useRef } from "react";
import "../../global.css";

const SOCIAL_LINKS = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61580815894015",
    icon: "/assets/img/icons/facebook.png",
    className: "vs-social-fb",
    tooltipBg: "#1877F2",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/viva.shri",
    icon: "/assets/img/icons/instagram.png",
    className: "vs-social-ig",
    tooltipBg: "linear-gradient(45deg, #f09433, #dc2743, #bc1888)",
  },
  {
    name: "X (Twitter)",
    url: "https://x.com/VIVA_SHRI",
    icon: "/assets/img/icons/x.png",
    className: "vs-social-x",
    tooltipBg: "#000000",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/vivashri/",
    icon: "/assets/img/icons/linkedin.png",
    className: "vs-social-li",
    tooltipBg: "#0A66C2",
  },
  {
    name: "Threads",
    url: "https://www.threads.com/@viva.shri",
    icon: "/assets/img/icons/threads.png",
    className: "vs-social-th",
    tooltipBg: "#111111",
  },
  {
    name: "YouTube",
    url: "https://youtube.com/@vivashri",
    icon: "/assets/img/icons/youtube.png",
    className: "vs-social-yt",
    tooltipBg: "#FF0000",
  }
];

function FloatingSocialBar() {
  const [isOpen, setIsOpen] = useState(true);
  const isOpenRef = useRef(true);
  const isHoveredRef = useRef(false);
  const scrollStopTimerRef = useRef(null);

  // Keep ref synchronized with state
  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      // If user is hovering over the bar, do not hide
      if (isHoveredRef.current) return;

      // Hide while scrolling
      if (isOpenRef.current) {
        setIsOpen(false);
      }

      // Clear previous timer
      if (scrollStopTimerRef.current) {
        clearTimeout(scrollStopTimerRef.current);
      }

      // When scrolling stops, restore visibility
      scrollStopTimerRef.current = setTimeout(() => {
        if (!isHoveredRef.current) {
          setIsOpen(true);
        }
      }, 10000);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      if (scrollStopTimerRef.current) {
        clearTimeout(scrollStopTimerRef.current);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMouseEnter = () => {
    isHoveredRef.current = true;
    if (scrollStopTimerRef.current) {
      clearTimeout(scrollStopTimerRef.current);
      scrollStopTimerRef.current = null;
    }
  };

  const handleMouseLeave = () => {
    isHoveredRef.current = false;
  };

  const toggleOpen = () => {
    if (scrollStopTimerRef.current) {
      clearTimeout(scrollStopTimerRef.current);
      scrollStopTimerRef.current = null;
    }
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className={`vsFloatSocialDock ${isOpen ? "is-open" : "is-collapsed"}`}
      aria-label="Social media links"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className="vsFloatSocialToggle"
        onClick={toggleOpen}
        aria-label={isOpen ? "Hide social links" : "Show social links"}
        title={isOpen ? "Hide" : "Show social links"}
      >
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {isOpen ? (
            <polyline points="15 18 9 12 15 6" />
          ) : (
            <polyline points="9 18 15 12 9 6" />
          )}
        </svg>
      </button>

      <div className="vsFloatSocialItemsList">
        {SOCIAL_LINKS.map((item) => (
          <a
            key={item.name}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`vsFloatSocialItem ${item.className}`}
            title={`Follow us on ${item.name}`}
            aria-label={item.name}
          >
            <img
              src={item.icon}
              alt={item.name}
              loading="lazy"
              className="vsSocialIconImg"
            />
            <span
              className="vsSocialTooltip"
              style={{ background: item.tooltipBg }}
            >
              {item.name}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default FloatingSocialBar;
